import React from "react";
import { motion } from "framer-motion";
import { HelpCircle } from "lucide-react";
import { useUiMode } from "../hooks/useUiMode";

export default function ClarificationCard({ question, options, context, selectedOption, answered, onSelect }) {
  const { uiMode } = useUiMode();
  const showContext = uiMode === "dev";
  return (
    <motion.div
      initial={{ opacity: 0, y: 4 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
      className="bg-blue-50/60 border border-blue-200 border-l-2 border-l-blue-500 rounded-lg p-4"
    >
      <div className="flex items-start gap-2.5">
        <HelpCircle className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" strokeWidth={2} />
        <div className="flex-1">
          {context && showContext && <div className="text-xs text-blue-700 mb-1.5 italic">{context}</div>}
          <div className="text-sm font-medium text-blue-900 mb-3 leading-relaxed">{question}</div>
          {options && options.length > 0 && (
            <div className="flex flex-wrap gap-2">
              {options.map((opt, i) => {
                const isSelected = answered && opt === selectedOption;
                const isDimmed = answered && opt !== selectedOption;
                const cls = isSelected
                  ? "px-3.5 py-1.5 bg-blue-600 text-white rounded-md text-sm font-medium cursor-default"
                  : isDimmed
                  ? "px-3.5 py-1.5 bg-white border border-blue-100 text-blue-300 rounded-md text-sm cursor-default"
                  : "px-3.5 py-1.5 bg-white border border-blue-200 text-blue-700 rounded-md text-sm hover:bg-blue-100 hover:border-blue-300 transition-all";
                return (
                  <button
                    key={i}
                    onClick={() => !answered && onSelect && onSelect(opt)}
                    disabled={answered}
                    className={cls}
                  >
                    {opt}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
}
